export default (function () {
  var w = typeof window !== 'undefined' ? window : global;
  return w.logger;
});